/** @jsxImportSource @gongxigames/framework/core/fragments/BuilderY */
/** @jsxRuntime automatic */

import {FC, $Container, $Sprite, mapProp} from '@gongxigames/framework/core/fragments/BuilderY';
import {$UIText} from '@gongxigames/framework/slotV2/ui/ui-koala/JSX/UIText';
import type {UIMainScreenUiProps} from './UIMainScreenUi';
import {computedFormatCents} from '@gongxigames/framework/slotV2/JSX/helpersFormat';

export const $TopPanelPortrait: FC<UIMainScreenUiProps> = (props) => {
    const balance = computedFormatCents(props.balance);
    const balanceTemplateValue = mapProp(balance, value => ({value}));

    return <$Container
        name='top_panel_portrait'
        responsive={{box: {width: '100%', height: '66px'}}}
    >
        <$Sprite
            name='background'
            texture='portrait_header_sys_ui'
            responsive={{box: {x: '0', y: '0', width: '100%'}, updateWidth: true}}
        />
        <$UIText
            responsive={{box: {y: '50%', x: '50%'}, translate: {y: '1px', x: '-22px'}}}
            localeID='creditPortrait'
            name='credit'
            stylePreset='BET_VALUE_PORTRAIT'
            values={balanceTemplateValue}
        />
    </$Container>;
};